/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';

import { buildUpgradeUrl } from './utils';
import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';

import { BannerProps } from './types';

export const shouldRender = (data: Result['data']) => {
  const { isTeamAccount, teamTrialEndDate } = data.currentAccount;
  return (
    !isTeamAccount && !!teamTrialEndDate && daysFromNow(teamTrialEndDate) <= 7
  );
};

export const Component = function TeamsTrialEnded(props: BannerProps) {
  const { getFullyQualifiedURL } = useUniversalNavContext();

  const { data } = props;
  const { currentAccount } = data;
  const upgradeUrl = buildUpgradeUrl({
    currentPlanName: currentAccount.plan.name,
    upgradePlanName: data.nextTeamPlan?.name,
    interval: currentAccount.plan.interval,
  });

  return (
    <Alert layout={props.layout} title="Your Team trial has ended" type="info">
      {/* Use `&nbsp;` to prevent text wrapping from making "Upgrade" a widow/orphan */}
      <Link href={getFullyQualifiedURL(upgradeUrl)}>Upgrade</Link>&nbsp;to keep
      your access to unlimited users, shared app connections, premier support,
      and more
    </Alert>
  );
};
